import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPageData } from "../../../redux/pageSlice";
import "./Logistics.css";
import { useVisibilityOnScroll } from "../../../Component/Hooks/useVisibilityOnScroll/useVisibilityOnScroll";
import VisibilitySection from "../../../Component/Hooks/useVisibilityOnScroll/VisibilitySection";
import TC3L from "../../../Component/ReuseComponent/TCLines/TC3L";
import { LoaderWrap } from "../../../Component/GlobalLoader/LoaderWrap";

export default function LogisticsArContent() {
  const { sectionsRef, visibilityStates } = useVisibilityOnScroll();
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.page);

  useEffect(() => {
    if (!data || data.length === 0) {
      dispatch(fetchPageData({ page_id: 10, lang: "ar" }));
    }
  }, [dispatch, data]);

  const section = data.find((s) => s.section_id === "1");

  return (
    <>
      <LoaderWrap>
        <div className="LogisticsContainer">
          <section>
            <LogisticsS1 section={section} />
          </section>
          <VisibilitySection index={1} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="LogisticsS2">
            <LogisticsS2 section={section} />
          </VisibilitySection>
        </div>
      </LoaderWrap>
    </>
  );
}
function LogisticsS1({ section }) {
  const sentences = section?.description?.split("،").filter(Boolean) || [];

  const Para = sentences
    .map((s, i) => {
      const sentence = s.trim();
      if (i < 2) return sentence + "، ";
      if (i === 2) return sentence + "<br /><br />";
      return sentence + ".";
    })
    .join("")
    .trim();

  return (
    <>
      <div className="LogisticsS1">
        <TC3L
          Head="توصيل آمن وطازج"
          Title={section?.title}
          Para={
            <>
              <div dangerouslySetInnerHTML={{ __html: Para }} />
            </>
          }
          ParaWidth="56vw"
          ParaWidthMob="89vw"
        />
      </div>
    </>
  );
}

function LogisticsS2({ section }) {
  return (
    <>
      <div className="LogisticsS3">
        <img src={section?.image} alt="" />
      </div>
    </>
  );
}
